import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';

const ImageViewer = ({
  open,
  onClose,
  title,
  imageUrl,
  imageAlt,
  isLoading,
  imageUrlForBottom,
  imageAltForBottom,
  ledMultipleBoxesUrl,
  ledMultipleBoxesUrlForBottom
}) => {
  const [zoomLevel, setZoomLevel] = useState(1);

  const handleZoomIn = () => {
    setZoomLevel(zoomLevel + 0.2);
  };

  const handleZoomOut = () => {
    if (zoomLevel > 0.2) {
      setZoomLevel(zoomLevel - 0.2);
    }
  };

  const handleClose = () => {
    setZoomLevel(1);
    onClose();
  };

  const hasLedImages = ledMultipleBoxesUrl || ledMultipleBoxesUrlForBottom;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90vw',
        height: '90vh',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        outline: 'none',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header */}
        <div style={{
          padding: '16px 20px',
          borderBottom: '1px solid #e0e0e0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0
        }}>
          <h2 id="modal-title" style={{ margin: 0, fontSize: '20px', fontWeight: 600 }}>{title}</h2>
          <div style={{ display: 'flex', gap: '8px' }}>
            <IconButton onClick={handleZoomIn} style={{ backgroundColor: '#e0e0e0' }} size="small">
              <AddIcon style={{ color: '#333' }} />
            </IconButton>
            <IconButton onClick={handleZoomOut} style={{ backgroundColor: '#e0e0e0' }} size="small">
              <RemoveIcon style={{ color: '#333' }} />
            </IconButton>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        {/* Content Area */}
        <div
          id="modal-description"
          style={{
            flex: 1,
            padding: '20px',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {isLoading ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%'
            }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {/* Normal Images Section */}
              {imageUrlForBottom ? (
                // Two images side by side
                <div style={{
                  display: 'flex',
                  gap: '20px',
                  width: '100%',
                  flex: 1
                }}>
                  {/* Top View */}
                  <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <h4 style={{
                      margin: '0 0 12px 0',
                      fontSize: '16px',
                      fontWeight: 600
                    }}>Top View</h4>
                    <div style={{
                      flex: 1,
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#fafafa',
                      padding: '12px',
                      overflow: 'auto',
                      minHeight: 0
                    }}>
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt={imageAlt}
                          style={{
                            maxWidth: '80%',
                            maxHeight: '80%',
                            objectFit: 'contain',
                            display: 'block',
                            transform: `scale(${zoomLevel})`,
                            transformOrigin: 'center center',
                            transition: 'transform 0.2s ease'
                          }}
                        />
                      ) : (
                        <span style={{ color: '#999' }}>No image available</span>
                      )}
                    </div>
                  </div>

                  {/* Bottom View */}
                  <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <h4 style={{
                      margin: '0 0 12px 0',
                      fontSize: '16px',
                      fontWeight: 600
                    }}>Bottom View</h4>
                    <div style={{
                      flex: 1,
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#fafafa',
                      padding: '12px',
                      overflow: 'auto',
                      minHeight: 0
                    }}>
                      {imageUrlForBottom ? (
                        <img
                          src={imageUrlForBottom}
                          alt={imageAltForBottom}
                          style={{
                            maxWidth: '80%',
                            maxHeight: '80%',
                            objectFit: 'contain',
                            display: 'block',
                            transform: `scale(${zoomLevel})`,
                            transformOrigin: 'center center',
                            transition: 'transform 0.2s ease'
                          }}
                        />
                      ) : (
                        <span style={{ color: '#999' }}>No image available</span>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                // Single image
                <div style={{
                  width: '100%',
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  {imageUrl ? (
                    <div style={{
                      flex: 1,
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      backgroundColor: '#fafafa',
                      padding: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'auto',
                      minHeight: 0
                    }}>
                      <img
                        src={imageUrl}
                        alt={imageAlt}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          display: 'block',
                          transform: `scale(${zoomLevel})`,
                          transformOrigin: 'center center',
                          transition: 'transform 0.2s ease'
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '60px',
                      color: '#999',
                      fontSize: '16px'
                    }}>
                      <span>No captured image present.</span>
                    </div>
                  )}
                </div>
              )}

              {/* LED Images Section */}
              {hasLedImages && (
                <div style={{
                  display: 'flex',
                  gap: '20px',
                  width: '100%',
                  flex: 1
                }}>
                  {/* LED Top View */}
                  {ledMultipleBoxesUrl && (
                    <div style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      <h4 style={{
                        margin: '0 0 12px 0',
                        fontSize: '16px',
                        fontWeight: 600
                      }}>LED Top View</h4>
                      <div style={{
                        flex: 1,
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#fafafa',
                        padding: '12px',
                        overflow: 'auto',
                        minHeight: 0
                      }}>
                        <img
                          src={ledMultipleBoxesUrl}
                          alt="LED Top View"
                          style={{
                            maxWidth: '80%',
                            maxHeight: '80%',
                            objectFit: 'contain',
                            display: 'block',
                            transform: `scale(${zoomLevel})`,
                            transformOrigin: 'center center',
                            transition: 'transform 0.2s ease'
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {/* LED Bottom View */}
                  {ledMultipleBoxesUrlForBottom && (
                    <div style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      <h4 style={{
                        margin: '0 0 12px 0',
                        fontSize: '16px',
                        fontWeight: 600
                      }}>LED Bottom View</h4>
                      <div style={{
                        flex: 1,
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#fafafa',
                        padding: '12px',
                        overflow: 'auto',
                        minHeight: 0
                      }}>
                        <img
                          src={ledMultipleBoxesUrlForBottom}
                          alt="LED Bottom View"
                          style={{
                            maxWidth: '80%',
                            maxHeight: '80%',
                            objectFit: 'contain',
                            display: 'block',
                            transform: `scale(${zoomLevel})`,
                            transformOrigin: 'center center',
                            transition: 'transform 0.2s ease'
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ImageViewer;